module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo09-miniaturka-b61313959549b8880d1868d9f8085db4.jpg";